import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/facebook-messenger': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256.6 8c140 0 247.4 102.3 247.4 240.6 0 175.1-166.2 273.2-319.4 231-9-2.4-9.6-0.6-62.6 22.7-2.1 0.9-5.7 1.7-8 1.7-10.6 0-19.5-8.6-19.9-19.2-1.4-46.4 0.3-50.7-8-58.2-48.4-43.2-78.1-105.6-78.1-177.9 0-138.2 108.5-240.6 248.6-240.6zM405.8 193.1c7-11.1-6.7-23.6-17.1-15.6l-78.4 59.4c-2.2 1.7-6.2 3-9 3s-6.8-1.3-9-3l-58.1-43.5c-5.5-4.1-15.5-7.4-22.4-7.4-11.3 0-25.5 7.8-31.6 17.4l-73 115.6c-7.1 11.1 6.6 23.6 17.1 15.7l78.4-59.4c2.2-1.7 6.2-3 9-3s6.8 1.3 9 3l58.1 43.5c5.5 4.1 15.5 7.4 22.4 7.4 11.3 0 25.5-7.8 31.6-17.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/facebook-messenger.js
// module id = 817
// module chunks = 0